// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","featuresContainer":"App_featuresContainer__22VRO"};